import { Component, OnInit, Input, ViewChild, TemplateRef } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { FormBuilder, FormGroup, FormControl, AbstractControl, Validators } from '@angular/forms';
import { Observable } from 'rxjs/Observable';
import { ToasterService } from 'angular2-toaster';
import swal from 'sweetalert2';
import * as _ from 'lodash';
import { Store } from '@ngrx/store';
import * as fromCommonStore from '../../../store';
import * as fromRootStore from '../../../reducers';
import * as moment from 'moment';
import { HamodelModel } from '../../../model/index';
import { HamodelService, CommonService } from '../../../services/index';
import { Subject } from 'rxjs/Subject';

@Component({
    selector: 'client-tab',
    templateUrl: './client.component.html',

})
export class ClientRejectTransactionComponent implements OnInit {
    @Input('tabTitle') title: string;
    @Input() active = false;
    @Input() isCloseable = false;
    @Input('params') params: string;
    //@Input() dataContext;

    public mode: string;
    public list: any[] = [];
    public stockList: any[] = [];
    numCtrl: FormControl;
    filteredBranch: Observable<any[]>;
    isLoadMask: Promise<any>;
    stockDet: HamodelModel[];
    isLoading: boolean = false;
    private searchTerms = new Subject<string>();
    filterData = {
        "search_data": ""
    };
    loadingIndicator: boolean = true;
    //reorderable: boolean = true;
    filteredParty: Observable<any[]>;
    filteredModel: Observable<any[]>;

    actModelList = [];
    clientList: any[] = [];
    filteredItems: Observable<any[]>;
    page = {
        limit: 25,
        count: 0,
        offset: 0,
        orderBy: 'stock_id',
        orderDir: 'desc'
    };

    @ViewChild('snoTemplate') snoTemplate: TemplateRef<any>;
    @ViewChild('editDeleteTemplate') editDeleteTemplate: TemplateRef<any>;
    @ViewChild('filterPanel') filterPanel;

    columns = [];
    scrollTimeout: any;
    suppressPaging: boolean = false;
    showBranch = true;
    subscribeBranch;
    showUpdate: boolean;
    clientDet: any[] = [];
    constructor( private hamodelService: HamodelService, public toasterService: ToasterService, private commonService: CommonService) {
        this.numCtrl = new FormControl('', [
            Validators.required
        ]);
    }

    ngOnInit(): void {
   
    }
    
   
    onClientReject(): void {
        var toast = {
            type: 'error',
            title: 'ERROR'
        };

        let that = this,
            data = {
                client_no: this.clientDet['client_no'],
                client_name: this.clientDet['client_name']
            };
            if (data.client_no == undefined || data.client_no == '') {
                swal('WARNING', 'Please Enter Client Number');
                return;
            }

            swal({
                title: 'Are you sure to Delete?',
                text: 'You will not be able to Recover Client No: ' + data.client_no + ' Again!',
                showCancelButton: true,
                confirmButtonText: 'Yes, Delete!',
                cancelButtonText: 'No, Keep it'
            }).then(function() {
                that.isLoading = true;
                that.isLoadMask = that.commonService
                .deleteCustomerEntries(data)
                    .then(function(res: any) {

                        that.isLoading = false;
                        if (res.success) {
                            that.clientDet = [];
                            swal('SUCCESS', res.message, 'success');
                            //  that.onReset();
                            // that.getStockList();
                        } else {
                            that.clientDet = [];
                            var toast = {
                                type: 'error',
                                title: 'ERROR',
                                body: res.message
                            };
                            that.toasterService.pop(toast);
                        }
                    });
    
            }, function(dismiss) {
    
            });

        // if (this.clientDet['client_no'] == 'client_no') {
            //  this.isLoading = true;
            // this.commonService
            //     .deleteCustomerEntries(data)
            //     .then(function (res: any) {
            //         that.isLoading = false;
            //         if (res.success) {
            //             // that.stockDet = [];
            //             swal('SUCCESS', res.message, 'success');
            //             //  that.onReset();
            //             // that.getStockList();
            //         } else {
            //             var toast = {
            //                 type: 'error',
            //                 title: 'ERROR',
            //                 body: res.message
            //             };
            //             that.toasterService.pop(toast);
            //         }
            //     });
        // }
    

    }

}



// WEBPACK FOOTER //
// /Applications/MAMP/htdocs/crm-soundsgood/src/app/components/dataCorrection/client_reject/client.component.ts